/* eslint-disable no-shadow */
import { APIGET, APIPOST } from '@/utils/apiHelper';

// initial state
const state = {
  deviceDisplayName: ' ',
};

// getters
const getters = {
  //
};

// actions
const actions = {
  async getDeviceByImei(context, imei) {
    return await APIGET(`device-management/product/${imei}/hu`);
  },
  async checkImeiByLuhn(context, imei) {
    return await APIGET(`device-management/luhn/${imei}/hu`);
  },
  async callMutation(context, displayName) {
    context.commit('setDeviceDisplayName', displayName);
  },
};

// mutations
const mutations = {
  setDeviceDisplayName(state, payload) {
    state.deviceDisplayName = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
